import React, { useContext } from "react";
import styled from "styled-components";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { navigate } from "gatsby-plugin-intl";

import { GlobalStateContext } from "Components/context";
import { parsePrice } from "../../utils";
import CurrencyData from "Components/common/intlPopup/currencyData";

const StyledWrapper = styled.div`
  width: 100%;
  display: inline-block;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  margin-bottom: 3rem;
`;

const StyledAssetWrapper = styled.div`
  background-color: ${(props) => props.theme.color.smoke};
  width: 100%;
`;

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.6rem;
`;

const StyledProductPrice = styled.div`
  margin-top: 0.4rem;
  font-size: 0.7rem;
  color: ${(props) => props.theme.color.dimGrey};
`;

const StyledTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
`;

const StyledSubtitle = styled.div`
  font-size: 0.7rem;
  font-weight: 100;
`;

export default function VariantCard({ style, shopifyVariant }) {
  const state = useContext(GlobalStateContext);
  const { currency } = state;
  const { color, design, kcID, lens, thumbnail } = style;

  let price = parsePrice(
    shopifyVariant?.presentmentPrices.find(
      (p) => p?.price?.currencyCode === currency
    )?.price?.amount || 0
  );
  let currencySymbol = CurrencyData[currency];
  const handleGoToProduct = (name) => {
    let colorQuery = encodeURI(color.name);
    let lensQuery = encodeURI(lens.name);
    navigate(
      `/product/${name
        .toLowerCase()
        .replace(/ /g, "")}?color=${colorQuery}&lens=${lensQuery}`
    );
  };
  return (
    <StyledWrapper onClick={() => handleGoToProduct(design.name)}>
      <StyledAssetWrapper>
        {thumbnail && (
          <GatsbyImage
            style={{ width: "100%", height: "100%" }}
            imgStyle={{
              objectFit: "contain",
              objectPosition: "center center",
            }}
            image={getImage(thumbnail?.imageFile)}
            alt="Product"
          />
        )}
      </StyledAssetWrapper>
      <StyledContent>
        <StyledTitle>{design.name}</StyledTitle>
        <StyledSubtitle>{`${color.name}/${lens.name}`}</StyledSubtitle>
        <StyledProductPrice>
          {currencySymbol}
          {price}
        </StyledProductPrice>
      </StyledContent>
    </StyledWrapper>
  );
}
